import { useState } from "react";
import Document from "../../../models/document";
import { getList } from "../../../api/generics";
import { getAbsoluteUrl } from "../../../api/urls";
import { fetchAuthenticated } from "../../../api/utils";
import { SUCCESS } from "../../../utils/constants/tags";
import { warningAlert } from "../../utils/messages";

const useDocumentVersions = () => {
  const [versionsModalVisible, setVersionsModalVisible] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<Document | null>(
    null
  );
  const [documentVersions, setDocumentVersions] = useState<any[]>([]);
  const [versionsLoading, setVersionsLoading] = useState(false);

  const handleOpenVersionsModal = async (document: Document) => {
    if (!document.id || document.id < 0) {
      warningAlert(
        "El documento debe ser guardado primero para ver sus versiones."
      );
      return;
    }

    setSelectedDocument(document);
    setVersionsLoading(true);
    setVersionsModalVisible(true);

    try {
      const versionsStatus = await getList(
        `/documents/${document.id}/versions/`,
        1000,
        0
      );

      if (versionsStatus.status === SUCCESS && versionsStatus.data?.items) {
        setDocumentVersions(versionsStatus.data.items);
      } else {
        setDocumentVersions([]);
        if (versionsStatus.status !== SUCCESS) {
          warningAlert(
            versionsStatus.detail || "Error al cargar las versiones"
          );
        }
      }
    } catch (error) {
      console.error("Error loading versions:", error);
      warningAlert("Error al cargar las versiones del documento");
      setDocumentVersions([]);
    } finally {
      setVersionsLoading(false);
    }
  };

  const handleCloseVersionsModal = () => {
    setVersionsModalVisible(false);
    setSelectedDocument(null);
    setDocumentVersions([]);
  };

  const handleDownloadVersion = async (versionId: string) => {
    if (!selectedDocument?.id) return;

    const downloadUrl = getAbsoluteUrl(
      `/documents/${selectedDocument.id}/get_document_url/?version=${versionId}`
    );

    const downloadResponse = await fetchAuthenticated(downloadUrl, {
      method: "GET",
    });

    if (!downloadResponse.ok) {
      throw new Error(
        `Error HTTP ${downloadResponse.status}: ${downloadResponse.statusText}`
      );
    }

    const blob = await downloadResponse.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = selectedDocument.filePath || "documento";

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  return {
    documentVersions,
    handleCloseVersionsModal,
    handleDownloadVersion,
    handleOpenVersionsModal,
    selectedDocument,
    versionsLoading,
    versionsModalVisible,
  };
};

export default useDocumentVersions;
